import { isLoyaltyDeactivatedLocale, Locale } from '@headless-workspace/config';
import { LoyaltyConfigsValue } from '../config';

export type ProductLoyaltyInfoValue = {
    pointsToEarn: number;
    pointsPerCurrency?: number;
};

export const mapProductLoyalty = (
    pointsToEarn: number | undefined,
    locale: Locale,
    config?: LoyaltyConfigsValue,
): ProductLoyaltyInfoValue | undefined => {
    if (!pointsToEarn || pointsToEarn <= 0) return undefined;
    if (config?.isEnableLoyaltyPoints === false) return undefined;
    if (config?.isEnableLoyaltyPoints === undefined && locale && isLoyaltyDeactivatedLocale(locale)) {
        return undefined;
    }

    return {
        pointsToEarn,
        pointsPerCurrency: config?.loyaltyPointsPerCurrency,
    };
};
